<template>
  <el-dialog
    :title="$t('shopWithdraw.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog">
    <div class="form-group row">
      <label class="col-sm-3 col-form-label">{{ $t('shopWithdraw.withdrawReason') }}</label>
      <div class="col-sm-9">
        <el-input
          type="textarea"
          v-model="shopWithdrawInfo.remark"
          :rows="3"
          :placeholder="$t('shopWithdraw.requiredRemark')">
        </el-input>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('shopWithdraw.cancel') }}</el-button>
      <el-button type="primary" @click="updateShopWithdraw">{{ $t('shopWithdraw.confirmWithdraw') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { auditShop } from '@/api/shop/shopApi'

export default {
  name: 'ShopWithdraw',
  data() {
    return {
      dialogVisible: false,
      shopWithdrawInfo: {
        remark: '',
        state: '001'
      }
    }
  },
  methods: {
    open(shop) {
      this.shopWithdrawInfo = { ...shop, remark: '', state: '001' }
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.shopWithdrawInfo = { remark: '', state: '001' }
    },
    updateShopWithdraw() {
      if (!this.shopWithdrawInfo.remark) {
        this.$message.warning(this.$t('shopWithdraw.requiredRemark'))
        return
      }

      auditShop(this.shopWithdrawInfo)
        .then(response => {
          console.log(response)
          this.$message.success(this.$t('shopWithdraw.processSuccess'))
          this.closeDialog()
          this.$emit('refresh')
        })
        .catch(error => {
          this.$message.error(this.$t('shopWithdraw.processFailed') + error)
        })
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 15px;
}
.col-form-label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>